<template>
  <div class="bestRateTrial">
    <div class="bestRateTrial-content">
      <div class="bestRateTrial-content-top">
        <p class="title">快速贴现试算</p>
        <div class="right">
          <span>今日最优利率</span>
          <p class="rate">银票<span>{{ (bestRate&&bestRate.length>0)?bestRate[0].rate: '0.00' }}</span>%</p>
        </div>
      </div>

      <div class="bestRateTrial-content-center pt30" v-if="process === 'input'">
        <Form class="banknum-body-form" ref="rateTrialForm" :model="form" :rules="rules" hide-required-mark label-position="top">
          <FormItem label="" prop="bankWholename">
            <Select v-model="form.bankWholename" clearable filterable :remote-method="bankDebounce" :loading="loading1" placeholder="输入承兑人关键词快速检索（例：招商）">
              <Option v-for="item in bankList" :value="item.value" :key="item.id">{{item.text}}</Option>
            </Select>
          </FormItem>
          <FormItem label="" prop="billAmount">
            <Input type="text" v-model="money" placeholder="请填写票面金额" v-text-only="{textType: 'double' }" @on-focus="form.billAmountStr = null" @on-blur="form.billAmountStr = formatMoney(form.billAmount)"></Input>
            <p class="positionrightcenter">{{form.billAmount ? digitUppercase(form.billAmount) : '元'}}</p>
          </FormItem>
          <FormItem label="" prop="dueDate">
            <DatePicker type="date" :open="dueDateOpen" :options="disabledEndDate" :value="form.dueDate" @on-change="handleDueDateChange">
              <div class="form-DatePicker" :style="{ color: (form.dueDate ? '#657180' : '#C3CBD6') }" @click="dueDateOpen = !dueDateOpen">
                {{form.dueDate || '请点击选择到期日'}}

                <span class="positionrightcenter" v-if="form.days">{{form.days}}</span>
                <svg-icon v-else class="f19 positionrightcenter" icon-class="Calendar"></svg-icon>
              </div>
            </DatePicker>
          </FormItem>
        </Form>
      </div>

      <div class="bestRateTrial-content-center pr" v-else-if="process === 'wait'">
        <div class="wait">
          <div class="waitBg">
            <i-circle :percent="waitPercent" stroke-color="#0098FE">
              <span class="demo-Circle-inner">试算中</span>
            </i-circle>
          </div>
        </div>
      </div>

      <div class="bestRateTrial-content-center bestRateTrialResult" v-else-if="process === 'success'">
        <p class="title"><i></i> <span>试算结果</span> <i></i></p>
        <div class="text">
          <p>承兑人：{{res.acceptor}}</p>
          <p>票面金额：{{formatMoney(res.billAmount)}}（{{digitUppercase(res.billAmount)}}）</p>
          <p>到期日：{{res.dueDate}}（{{form.days}}）</p>
        </div>

        <div class="res">
          <span class="label">最优选择</span>

          <div class="bank">
            <i class="dl wh20" :style="logoStyle(res.bankCode)"></i>{{res.bankName}}
            <p class="rate">贴现利率：<span>{{res.rate.mul(100)}}%</span></p>
          </div>

          <div class="data">
            <div>
              <p>{{formatMoney(res.billAmount)}}</p>
              <p>票面金额</p>
            </div>
            <p>-</p>
            <div>
              <p>{{formatMoney(Number(res.billAmount.sub(res.discountAmount).toFixed(2)))}}</p>
              <p>扣息</p>
            </div>
            <p>=</p>
            <div>
              <p>{{formatMoney(res.discountAmount)}}</p>
              <p>贴现可得金额</p>
            </div>
          </div>
        </div>
      </div>

      <div class="bestRateTrial-content-bottom">
        <p class="tip">*试算结果仅供参考，以实际下单结果为准。</p>

        <div class="btnBg" v-if="process === 'input'">
          <Button type="primary" class="w230" :disabled="isDisabled" @click="onSubmit">立即试算</Button>
          <Button type="primary" ghost class="reset w90" @click="onReset">重置</Button>
        </div>

        <div class="btnBg" v-else-if="process === 'wait'">
          <Button type="primary" class="w100b" @click="onCancel">取消</Button>
        </div>

        <div class="btnBg" v-else-if="process === 'success'">
          <Button type="primary" class="w230" @click="$router.push('/ApplicationDiscount')">立即下单</Button>
          <Button type="primary" ghost class="w90" @click="onCancel">重新试算</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['bestRate'],
  data () {
    this.bankDebounce = this.debounce(this.handleBank, 500)

    return {
      process: 'input', // input-表单输入， wait-等待， success-试算成功

      lowerRate: 0,

      loading1: false,
      bankList: [],
      waitPercent: 0,

      dueDateOpen: false,
      disabledEndDate: {
        disabledDate: (endValue) => {
          return new Date().getTime() > new Date(endValue).getTime();
        }
      },
      init: {
        billAmountStr: null,
        bankWholename: null,
        billAmount: null,
        dueDate: null,
        days: null,
      },
      form: {},
      res: {},
      rules: {
        bankWholename: { required: true, message: '请输入总行名称', trigger: 'blur' },
        billAmount: { required: true, message: '请输入票面金额', trigger: 'blur' },
        dueDate: { required: true, message: '请选择到期日', trigger: 'change' }
      },
    }
  },
  computed: {
    money: {
      get () {
        return this.form.billAmountStr || this.form.billAmount
      },
      set (newVal) {
        this.form.billAmount = newVal
      }
    },
    isDisabled () {
      return !(this.form.bankWholename && this.form.billAmount && this.form.dueDate)
    }
  },
  mounted () {
    // this.getLowerRate()
    this.form = this.deepCopy(this.init)
  },
  methods: {
    // 获取最低利率
    // getLowerRate () {
    //   this.sendGet({
    //     url: '/web/discount-bank-quote/bestTheTrialDiscountRate'
    //   }, res => {
    //     console.log(res, '========= aaa');
    //     this.lowerRate = res.data.data
    //   }, err => {
    //     console.warn(err);
    //   })
    // },

    // 模糊匹配总行名称
    handleBank (query) {
      if (query !== '') {
        this.loading1 = true;

        this.sendGet({
          url: '/trade-center/bill-acceptor/page',
          data: { sidx: 'createTime', sord: 'asc', searchKey: query, page: 1, rows: 10, }
        }, res => {
          res = res.data
          console.log(res.data);
          this.bankList = this.deepCopy(res.data.content).map(v => ({ value: v.name, text: v.name, id: v.id, item: v }))
          this.loading1 = false;
        }, err => {
          console.log(err);
        })
      } else {
        this.bankList = [];
      }
    },
    // 自定义日期格式改变事件
    handleDueDateChange (date) {
      this.form.dueDate = date;
      this.dueDateOpen = false;

      this.sendGet({
        url: '/web/bill/getDueDays',
        data: {
          dueDate: this.form.dueDate
        }
      }, res => {
        this.form.days = res.data.data
      }, err => { })
    },
    onSubmit () {
      this.$refs.rateTrialForm.validate((valid) => {
        if (valid) {
          this.getResult()
        } else {
          this.$Message.error('Fail!');
        }
      })
    },
    getResult () {
      this.waitPercent = 0
      this.process = 'wait'
      this.waitPercentFn()
      this.res = {}

      this.sendGet({
        url: '/web/discount-bank-quote/queryTheTrialDiscountRate',
        data: {
          acceptor: this.form.bankWholename,
          dueDate: this.form.dueDate,
          billAmount: this.form.billAmount
        }
      }, res => {
        this.res = res.data.data
      }, err => {
        this.waitPercent = 100

        setTimeout(() => {
          this.process = 'input'
        }, 500);
      })
    },
    waitPercentFn () {
      function fn () {
        let random = Math.floor(Math.random() * 10000000000) % 23

        this.timer = setTimeout(() => {
          this.waitPercent = Math.min(this.waitPercent + random, 100);

          clearTimeout(this.timer);

          if (this.process !== 'wait') return false;

          if (this.waitPercent != 100) {
            fn.call(this)
            return;
          }

          if (this.res.billAmount) {
            setTimeout(() => {
              this.process = 'success'
            }, 300)
          } else {
            this.waitPercent = this.waitPercent - Math.floor(Math.random() * 1000000000000) % 50
            setTimeout(fn.bind(this), 300)
          }
        }, 500);
      }
      fn.call(this)
    },
    onReset () {
      this.form = this.deepCopy(this.init)
      this.$refs.rateTrialForm.resetFields();
    },
    onCancel () {
      this.process = 'input'
    }
  }
}
</script>

<style lang="less" scoped>
.bestRateTrial {
  width: 412px;
  height: 100%;
  padding: 42px 41px 48px 0px;
  background: url(~@/assets/img/home/new.png) no-repeat right top;

  &-content {
    padding-left: 41px;
    width: 100%;
    height: 100%;
    border-left: 1px solid #d8d8d8;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    &-top {
      width: 100%;

      .title {
        height: 25px;
        line-height: 25px;
        font-size: 20px;
        font-weight: bold;
        color: #333;
      }
      .right {
        padding-top: 7px;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        > span {
          display: inline-block;
          line-height: 21px;
          font-size: 14px;
          text-align: center;
          margin-right: 12px;
        }
        .rate {
          width: 104px;
          height: 23px;
          background: #556bff;
          border-radius: 12px;
          font-size: 12px;
          color: #fff;
          font-weight: bold;
          text-align: center;
          line-height: 23px;

          span {
            margin-left: 5px;
          }
        }
      }
    }
    &-center {
      flex: 1;
      width: 100%;

      /deep/.ivu-date-picker,
      /deep/.ivu-date-picker-rel {
        width: 100%;
      }
      .form-DatePicker {
        display: inline-block;
        width: 100%;
        height: 32px;
        line-height: 1.5;
        padding: 4px 7px;
        border: 1px solid #d7dde4;
        border-radius: 4px;
        position: relative;
        text-align: left;
      }
      .positionrightcenter {
        position: absolute;
        top: 50%;
        right: 8px;
        transform: translateY(-50%);
      }
      .date-tip {
        width: 20px;
        height: 20px;
        border: 1px solid #d7dde4;
        border-radius: 50%;
        right: -30px;
        text-align: center;
        cursor: pointer;

        p {
          display: none;
          width: auto;
          height: auto;
          white-space: nowrap;
          text-align: left;
          padding: 5px 8px;
          border-radius: 4px;
          position: absolute;
          bottom: 27px;
          left: -6px;
          border: 1px solid #d7dde4;
          background: #fff;
          color: #333;

          &:after {
            display: block;
            width: 0;
            height: 0;
            content: '';
            border-top: 6px solid #fff;
            border-left: 6px solid transparent;
            border-right: 6px solid transparent;
            position: absolute;
            bottom: -6px;
            left: 8px;
          }
          &:before {
            display: block;
            width: 0;
            height: 0;
            content: '';
            border-top: 6px solid #d7dde4;
            border-left: 7px solid transparent;
            border-right: 7px solid transparent;
            position: absolute;
            bottom: -7px;
            left: 7px;
          }
        }
        &:hover p {
          display: block;
        }
      }

      .wait {
        width: 130px;
        height: 130px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        /deep/.demo-Circle-inner {
          font-size: 14px;
          color: #666;
        }
      }

      &.bestRateTrialResult {
        .title {
          margin-top: 20px;
          text-align: center;
          font-size: 14px;
          font-weight: bold;
          color: #000000;
          line-height: 21px;
          position: relative;
          span {
            margin: 0px 5px;
          }

          i {
            display: inline-block;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background: #ccc;
            vertical-align: 1px;
          }

          &:after,
          &:before {
            display: block;
            content: '';
            width: 125px;
            height: 1px;
            background: #ccc;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
          }
          &:before {
            left: 0;
          }
          &:after {
            right: 0;
          }
        }
        .text {
          font-size: 14px;
          line-height: 25px;
        }
        .res {
          margin-top: 8px;
          padding: 10px;
          background: #f3faff;
          border: 1px dashed #333;

          .label {
            display: inline-block;
            width: 60px;
            height: 16px;
            background: #e1241a;
            border-radius: 8px;
            font-size: 12px;
            color: #ffffff;
            line-height: 18px;
            text-align: center;
          }

          .bank {
            height: 49px;
            position: relative;
            font-size: 14px;
            padding-top: 5px;
            i {
              margin-right: 3px;
              vertical-align: -4px;
            }

            .rate {
              width: 155px;
              height: 37px;
              line-height: 37px;
              position: absolute;
              right: -10px;
              top: 0px;
              background: linear-gradient(307deg, #e2f3ff 0%, #c0e5ff 100%);
              text-align: center;
              padding-left: 13px;
              font-size: 14px;

              span {
                color: #e1241a;
                font-weight: bold;
              }

              &:after {
                display: block;
                content: '';
                width: 0px;
                height: 0px;
                border-top: 37px solid #f3faff;
                border-right: 23px solid transparent;
                position: absolute;
                top: 0px;
                left: 0px;
              }
            }
          }

          .data {
            display: flex;
            justify-content: space-between;
            align-items: center;

            > div {
              font-size: 12px;

              p:last-child {
                color: #666666;
              }
            }
          }
        }
      }
    }

    &-bottom {
      width: 100%;
      align-self: flex-end;

      .tip {
        height: 12px;
        line-height: 18px;
        font-size: 12px;
        color: #666;
        margin-bottom: 14px;
      }

      .btnBg {
        height: 35px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;

        button {
          height: 45px;
          line-height: 33px;
        }

        .ivu-btn-primary:disabled {
          background: #e1241a;
          opacity: 0.4;
          color: #ffffff;
          border-color: #e1241a;
        }
      }
    }
  }
}

.coutdown-animate {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 50%;
  opacity: 0.3;

  &:before {
    content: '';
    display: block;
    margin-left: 50%;
    height: 100%;
    background-color: inherit;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0 50px 50px 0;
    transform-origin: left;
  }
  &.animate {
    background: #fff;
    background-image: linear-gradient(to right, transparent 50%, #ffdede 0);

    &:before {
      animation: spin 1.5s linear infinite, bg 3s step-end infinite;
    }
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(180deg);
  }
}
@keyframes bg {
  50% {
    background: #ffdede;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/home/HomeBestRateTrial.vue